export const formatHeatmapHourLabel = time24 => {
  if (typeof time24 !== 'string') return '';
  if (/AM|PM/i.test(time24)) return time24;
  if (!/^\d{1,2}:\d{2}$/.test(time24)) return time24;

  const [hhStr, mm] = time24.split(':');
  const hh = Number(hhStr);
  const period = hh >= 12 ? 'PM' : 'AM';
  const hh12 = hh % 12 === 0 ? 12 : hh % 12;

  return mm === '00' ? `${hh12} ${period}` : `${hh12}:${mm} ${period}`;
};
